<template>
  <div class="data-express">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="info" @click="goBack">返回</el-button>
        <el-button type="primary" @click="addOrUpdateHandle($route.params.id)"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 表格展示区域 -->
    <el-table :data="dataInfo" border style="width: 100%">
      <el-table-column align="center" type="index" width="50" label="#">
      </el-table-column>
      <el-table-column
        prop="timePeriod"
        align="center"
        label="年度"
        width="280"
      >
      </el-table-column>
      <el-table-column
        prop="numericalValue"
        align="center"
        label="数值变化"
        width="180"
      >
        <template slot-scope="scope">
          {{
            scope.row.numericalValue * 1 > 0
              ? `上升了${scope.row.numericalValue}%`
              : `下降了${Math.abs(scope.row.numericalValue)}%`
          }}
        </template>
      </el-table-column>
      <el-table-column prop="transaction" align="center" label="销售额(亿元)">
      </el-table-column>
      <el-table-column prop="description" align="center" label="描述">
      </el-table-column>

      <!-- 排序 -->
      <el-table-column prop="sort" label="排序" align="center" width="70">
        <template slot-scope="scope">
          <el-input
            class="e-input"
            v-model.number="scope.row.sort"
            @blur="updateSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="250" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="addOrUpdateHandle($route.params.id, scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 修改弹窗 -->
    <add-or-update-detail
      ref="addOrUpdateDetail"
      @dataListUpdate="getDataDetailInfo"
    >
    </add-or-update-detail>
    <!-- <el-pagination
            background
            layout="prev, pager, next"
            :total="activitiesTotal"
            @current-change="pageChange"
            :page-size="dataQuery.limit"
            :current-page="dataQuery.page"
        >
        </el-pagination> -->
  </div>
</template>

<script>
import addOrUpdateDetail from "./add-or-update-detail.vue";
export default {
  components: {
    addOrUpdateDetail,
  },
  data() {
    return {
      dataInfo: [], //数据快报详细信息
      dataTotal: "",
      /* dataQuery:{
                page:1,
                limit:10
            } */
    };
  },
  methods: {
    goBack(){
        this.$router.go(-1)
    },
    //获取数据快报详细信息
    async getDataDetailInfo() {
      let { data } = await this.$ajaxGet(
        `/bulletin/open/selectDataBulletinList?pid=${this.$route.params.id}`
      );
      console.log(data, "数据快报详情");
      if (data.code === 0) {
        this.dataInfo = data.data;
      }
    },
    // 分页器页数改变事件
    /* pageChange(val) {
            this.dataQuery.page = val;
        }, */
    //修改按钮的回调
    addOrUpdateHandle(pid, id) {
      this.$nextTick(() => {
        this.$refs.addOrUpdateDetail.init(pid, id);
      });
    },

    // 排序框失去焦点时保存排序
    updateSort(item) {
      const { id, sort } = item;
      this.$ajaxPost("/bulletin/update", { id: parseInt(id), sort }).then(
        ({ data }) => {
          if (data.code === 0) {
            this.$message.success("排序更新成功");
            this.getDataDetailInfo();
          }
        }
      );
    },

    //删除按钮的回调
    deleteHandle(id) {
      this.$confirm("此操作将永久删除该条目,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajaxGet(`/bulletin/deleteDataBulletin?id=${[id]}`).then(
            ({ data }) => {
              if (data.code === 0) {
                this.getDataDetailInfo();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  mounted() {
    this.getDataDetailInfo();
  },
};
</script>

<style lang="less" scoped>
.data-express {
  background: #fff;
  padding: 5px 20px;
}
.e-input {
  input {
    text-align: center;
  }
}
.e-input {
  /deep/.el-input__inner {
    text-align: center;
  }
}
</style>